import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const sections = [
    {
        title: "1. The service",
        body: "RealtorReferral.ca (the \"Service\") is operated by Thom Gallagher, Sales Representative, iCloud Realty Ltd. The Service is a real-estate referral matching service that personally connects buyers and sellers in Canada with up to three vetted real-estate agents whose practice profiles fit their needs.",
    },
    {
        title: "2. No fees to the consumer",
        body: "There is no charge to you, the consumer, for using the Service. When a transaction successfully closes with an agent introduced to you through the Service, the receiving brokerage pays a referral fee to iCloud Realty Ltd from their commission, documented using a standard Referral Agreement signed by you, RealtorReferral.ca (iCloud Realty Ltd as the referring brokerage), and the receiving brokerage. This referral fee does not increase your purchase price or reduce your sale price.",
    },
    {
        title: "3. No guarantee of outcome",
        body: "While we screen the agents in our network for experience, professionalism, communication style, and local market depth, we cannot and do not guarantee any specific real-estate outcome. The decisions whether to engage an introduced agent, what offer to make on a property, what price to list a property at, and whether to accept any particular offer are entirely yours, made with the advice of your chosen agent and other professionals (lawyer, mortgage broker, home inspector, etc.).",
    },
    {
        title: "4. No agency relationship until you sign one",
        body: "Submitting a matching request through this site does not create a real-estate agency relationship between you and Thom Gallagher, iCloud Realty Ltd, or any agent introduced to you. An agency relationship is only created when you sign a written representation agreement (such as a Buyer Representation Agreement or Listing Agreement) with the receiving agent's brokerage.",
    },
    {
        title: "5. Third-party services",
        body: "We use third-party services to operate the site, including Calendly for booking introductory calls, Resend for transactional email, and MongoDB for secure data storage. Their use of any information you provide to them through our site is governed by their own privacy policies and terms of service.",
    },
    {
        title: "6. Content and intellectual property",
        body: "All content on this site — articles, images, copy, and design — is owned by RealtorReferral.ca or its licensors and is provided for informational purposes only. The articles in the Journal section are general in nature and should not be relied on as legal, financial, or real-estate advice for your specific situation; always consult a qualified licensed professional before making decisions.",
    },
    {
        title: "7. Limitation of liability",
        body: "To the maximum extent permitted by law, RealtorReferral.ca, Thom Gallagher, and iCloud Realty Ltd are not liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Service or from your engagement with any agent introduced to you through the Service. Your sole remedy in the event of dissatisfaction with the Service is to discontinue using it.",
    },
    {
        title: "8. Privacy",
        body: "Our handling of your personal information is governed by our Privacy Policy, which forms part of these Terms.",
    },
    {
        title: "9. Governing law",
        body: "These Terms are governed by the laws of the Province of Ontario and the federal laws of Canada applicable therein. Any disputes arising from these Terms or the Service shall be submitted to the exclusive jurisdiction of the courts of Ontario.",
    },
    {
        title: "10. Changes to these terms",
        body: "We may update these Terms from time to time. The current version is identified by the version code at the bottom of this page. Material changes will be noted on the site, and continued use of the Service after the change indicates acceptance of the updated Terms.",
    },
    {
        title: "11. Contact",
        body: "Questions about these Terms can be sent to hello@realtorreferral.ca. Privacy-related questions should be directed to privacy@realtorreferral.ca.",
    },
];

export default function TermsPage() {
    return (
        <div className="bg-brand-paper" data-testid="terms-page">
            <section className="mx-auto max-w-3xl px-6 lg:px-10 pt-20 lg:pt-28 pb-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-5">
                        — Legal
                    </div>
                    <h1 className="font-serif text-5xl lg:text-7xl leading-[1.05] tracking-tight text-brand-ink">
                        Terms of <span className="italic">Service</span>
                    </h1>
                    <p className="mt-8 text-lg text-brand-muted leading-relaxed">
                        The terms under which you may use RealtorReferral.ca. By submitting a matching
                        request, you agree to these terms.
                    </p>
                    <p className="mt-4 text-xs uppercase tracking-wider text-brand-muted">
                        Last updated: 21 May 2026 · Version v1.1-2026-05-21
                    </p>
                </motion.div>
            </section>

            <section className="mx-auto max-w-3xl px-6 lg:px-10 pb-24 lg:pb-32 space-y-10">
                {sections.map((s, i) => (
                    <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.5, delay: i * 0.05 }}
                        className="border-t border-brand-line pt-8"
                    >
                        <h2 className="font-serif text-2xl lg:text-3xl text-brand-ink mb-4 leading-tight">
                            {s.title}
                        </h2>
                        <p className="text-lg text-brand-ink/85 leading-relaxed">{s.body}</p>
                    </motion.div>
                ))}
                <div className="border-t border-brand-line pt-8 text-sm text-brand-muted">
                    See also our <Link to="/privacy-policy" className="text-brand-ink underline">Privacy Policy</Link>.
                </div>
            </section>
        </div>
    );
}
